import React, { ButtonHTMLAttributes } from "react";
import { Link, LinkProps as RouterLinkProps } from "react-router-dom";

interface LinkProps extends RouterLinkProps {
    to: string,
    text?: string,
    children?: React.ReactNode;
}


interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>  {
    text?: string,
    children?: React.ReactNode;
}



const PrimaryLink: React.FC<LinkProps>  = ({text, children, to, ...props}) => {

    const isExternal = typeof to === "string" && to.startsWith("http");
    const doesntLink = typeof to === "string" && to.startsWith("#");

    if (doesntLink) {
      return <a {...props} className="bg-[#FEBE58] cursor-pointer min-h-[45px] flex justify-center place-items-center p-3">
          {children || text}
      </a>
    }

    return isExternal ? (
        <a 
          href={to} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="bg-[#FEBE58] min-h-[45px] flex justify-center place-items-center p-3"
        >
          {children || text}
        </a>
      ) : (
        <Link 
          to={to} 
          className="bg-[#FEBE58] min-h-[45px] flex justify-center place-items-center p-3"
        >
          {children || text}
        </Link>
      )
}

const SecondaryLink: React.FC<LinkProps>  = ({text, children, ...props}) => {
    return <Link to={props.to}  className="bg-[#240738] min-h-[45px] flex justify-center place-items-center cursor-pointer p-3">
        { children || text }
    </Link>
}


const SliderNextButton: React.FC<ButtonProps> = ({text, children, ...props}) => {
    return <button className="flex place-items-center gap-x-5 group" onClick={props.onClick} disabled={props.disabled}>
        <div className="w-20 h-0.5 bg-black group-disabled:opacity-10"></div>
        <span className="tf-inter font-extralight text-xs group-hover:font-extrabold group-disabled:opacity-10">Next</span>
    </button>
}


const SliderPreviousButton: React.FC<ButtonProps> = ({text, children, ...props}) => {
    return <button className="flex group place-items-center gap-x-5" onClick={props.onClick} disabled={props.disabled}>
        <span className="tf-inter font-extralight text-xs group-hover:font-extrabold group-disabled:opacity-10">Prev</span>
        <div className="w-20 h-0.5 bg-black  group-disabled:opacity-10"></div>
    </button>
}



export default PrimaryLink
export {
    SecondaryLink,
    SliderNextButton,
    SliderPreviousButton
}